class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Initialize properties
        this.freeShippingEligible = 0;
        this.shipVal = "Free";
        
        // Find DOM elements
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');
        
        // Check if required elements exist
        if (!this.progressBar || !this.messageElement || !this.progressMeter) {
            console.error('Free shipping component: Required DOM elements not found');
            return;
        }
        
        this.textEnabled = this.progressBar.dataset.textEnabled === 'true';
        
        // Get settings from data attributes (threshold is in cents, current is in cents)
        this.threshold = parseInt(this.dataset.threshold) || 10000; // Default to $100 (10000 cents)
        this.currentTotal = parseInt(this.dataset.current) || 0;
        
        // Get messages from data attributes or use defaults
        this.achievedMessage = this.dataset.achievedMessage || "🎉 You've earned FREE shipping!";
        this.needsMoreMessage = this.dataset.needsMoreMessage || "Add $X more for FREE shipping!";

        // Add event listeners
        this.addEventListener('change', this.onCartChange.bind(this));
        
        // Listen for cart update events from other components
        document.addEventListener('cart:updated', (event) => {
            if (event.detail && event.detail.cartData) {
                this.updateFromCartData(event.detail.cartData);
            }
        });

        // Initialize with current cart data
        this.initialize();
    }

    initialize() {
        fetch('/cart.js')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch cart data');
                }
                return response.json();
            })
            .then(cart => {
                this.cart = cart;
                this.calculateProgress(cart);
            })
            .catch(error => {
                console.error('Error fetching cart data:', error);
                // Fallback to initial state
                this.calculateProgress({ total_price: 0 });
            });
    }

    onCartChange(e) {
        this.initialize();
    }
    
    // Method to update from external cart changes
    updateFromCartData(cartData) {
        if (cartData && cartData.total_price !== undefined) {
            this.calculateProgress(cartData);
        }
    }

    calculateProgress(cart) {
        const cartTotalPrice = parseInt(cart.total_price);
        const thresholdInCents = this.threshold;
        
        console.log('Free shipping calculation:', {
            cartTotalCents: cartTotalPrice,
            cartTotalDollars: (cartTotalPrice / 100).toFixed(2),
            thresholdCents: thresholdInCents,
            thresholdDollars: (thresholdInCents / 100).toFixed(2),
            achievedMessage: this.achievedMessage,
            needsMoreMessage: this.needsMoreMessage
        });
        
        // Calculate percentage (0-100)
        let percentage = Math.round((cartTotalPrice * 100) / thresholdInCents);
        if (percentage >= 100) {
            percentage = 100;
        }
        
        const text = this.getText(cartTotalPrice, thresholdInCents, percentage);
        const classLabel = this.getClassLabel(percentage);

        this.setProgressWidthAndText(percentage, text, classLabel);
    }

    getText(cartTotalPrice, thresholdInCents, percentage) {
        let text;

        if (cartTotalPrice === 0) {
            this.progressBar.classList.add('progress-hidden');
            text = this.needsMoreMessage.replace('$X', this.formatMoney(thresholdInCents));
        } else if (cartTotalPrice >= thresholdInCents) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            text = this.achievedMessage;
        } else {
            this.progressBar.classList.remove('progress-hidden');
            const remainingPrice = thresholdInCents - cartTotalPrice;
            text = this.needsMoreMessage.replace('$X', this.formatMoney(remainingPrice));
            this.shipVal = "TBD";
        }

        return text;
    }
    
    formatMoney(cents) {
        // Convert cents to dollars and format
        const dollars = cents / 100;
        return '$' + dollars.toFixed(2);
    }

    getClassLabel(percentage) {
        let classLabel;

        if (percentage === 0) {
            classLabel = 'progress-0';
        } else if (percentage <= 30) {
            classLabel = 'progress-30';
        } else if (percentage <= 60) {
            classLabel = 'progress-60';
        } else if (percentage < 100) {
            classLabel = 'progress-90';
        } else {
            classLabel = 'progress-100';
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        // Remove all progress classes
        this.progressBar.classList.remove('progress-0');
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-90');
        this.progressBar.classList.remove('progress-100');

        // Add the current class
        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(percentage, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);

            // Update progress bar width
            if (this.progressMeter) {
                this.progressMeter.style.width = `${percentage}%`;
            }
            
            // Update percentage text if enabled
            if (this.textEnabled) {
                const textElement = this.progressMeter?.querySelector('.text');
                if (textElement) {
                    textElement.innerHTML = `${percentage}%`;
                }
            }

            // Update message
            if (this.messageElement) {
                this.messageElement.innerHTML = text;
            }


        }, 100); // Reduced timeout for better responsiveness
    }
}

// Define the custom element immediately
customElements.define('free-shipping-component', FreeShippingMeter);

// Initialize any existing elements
document.addEventListener('DOMContentLoaded', () => {
    const existingElements = document.querySelectorAll('free-shipping-component');
    existingElements.forEach(element => {
        if (!element.initialized) {
            element.connectedCallback();
            element.initialized = true;
        }
    });
});